import { z } from "zod"

const customerProductFileFormSchema = z.object({
  file: z
    .instanceof(File)
    .nullable()
    .refine((file) => file !== null, { message: "File is required" }),
  fileDescription: z.string().max(64, "Description must not exceed 64 characters").optional(),
  fileType: z.string().min(1, "File type is required"),
})

export type CustomerProductFileFormValues = z.infer<typeof customerProductFileFormSchema>

export const customerProductFileArrayFormSchema = z.object({
  files: z.array(customerProductFileFormSchema),
})

export type CustomerProductFileArrayFormValues = z.infer<typeof customerProductFileArrayFormSchema>
